import { render, staticRenderFns } from "./PopupReferenceTable.vue?vue&type=template&id=e447fa78&scoped=true&"
import script from "./PopupReferenceTable.vue?vue&type=script&lang=js&"
export * from "./PopupReferenceTable.vue?vue&type=script&lang=js&"
import style0 from "./PopupReferenceTable.vue?vue&type=style&index=0&id=e447fa78&lang=scss&scoped=true&"
import style1 from "./PopupReferenceTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e447fa78",
  null
  
)

export default component.exports